import 'jsdc-dui/dist/i18n/config';
import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as ReactDOMClient from 'react-dom/client';

const root = ReactDOMClient.createRoot(
  document.getElementById('root') as Element
)
root.render(
  <>
    <div className='border-deco'>
      <div className="border-deco-sub1">
        <div className="border-deco-sub2">
          <div className="border-deco-sub3">
            <div className="border-deco-sub4"></div>
          </div>
        </div>
      </div>
    </div>
    <App />
  </>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
